var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"menutoggle pull-left",attrs:{"id":"menuToggle"},on:{"click":_vm.openCloseLeftMenu}},[_c('i',{staticClass:"fa fa fa-tasks"})])}
var staticRenderFns = []

export { render, staticRenderFns }